import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var BalanceOf = createPlugin({
    protocol: 'ERC721',
    type: 'GETTER',
    method: 'balanceOf',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721' }),
                methodParams: {
                    owner: new FctAddress({}),
                },
            },
            output: {
                balance: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
            },
        });
    },
});
